import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginForm from './loginform/index';
import Homepage from './homepage/index'
import Popup from './popup/index'
import Homepagee from './homepage/index copy'
import PrivateRoute from './PrivateRoute';

const App = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          {/* <Route path="/home" element={<Homepage />} /> */}
          <Route
          path="/home"
          element={
            <PrivateRoute>
              <Homepage />
            </PrivateRoute>
          }
        />
          <Route path="/Popup" element={<Popup />} />
          <Route path="/copy" element={<Homepagee />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}
 
export default App;
